if (!customElements.get('dd-story-player')) {
  customElements.define('dd-story-player', class extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.dd-home-stories');
      this.dialog = this.querySelector('dialog');
      this.player = this.querySelector('.dd-home-stories__player');
      this.listeners = new AbortController();
      const options = { signal: this.listeners.signal };

      this.section.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-youtube-id]');
        if (!trigger || event.defaultPrevented || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        if (this.dialog.open) return;

        this.trigger = trigger;
        const iframe = document.createElement('iframe');
        iframe.title = trigger.getAttribute('aria-label') || 'Story video';
        iframe.src = `https://www.youtube.com/embed/${encodeURIComponent(trigger.dataset.youtubeId)}?autoplay=1&playsinline=1&rel=0`;
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        iframe.allowFullscreen = true;
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        this.dialog.setAttribute('aria-label', iframe.title);
        this.player.replaceChildren(iframe);
        this.previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.dialog.showModal();
      }, options);

      this.querySelector('button').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) {
          this.dialog.close();
        }
      }, options);
      this.dialog.addEventListener('close', () => this.reset(), options);
    }

    reset() {
      this.player.replaceChildren();
      if (this.previousOverflow !== undefined) {
        document.documentElement.style.overflow = this.previousOverflow;
        this.previousOverflow = undefined;
      }
      if (this.trigger?.isConnected) this.trigger.focus({ preventScroll: true });
      this.trigger = null;
    }

    disconnectedCallback() {
      this.listeners.abort();
      if (this.dialog.open) this.dialog.close();
      this.reset();
    }
  });
}
